import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/navigation/PrivateRoute';
import { useAppDispatch } from './hooks/store';
import { useLazyInitQuery } from './store/api/common';
import { saveInit } from './store/slices/global';

function App() {
    const dispatch = useAppDispatch();
    const [triggerInit] = useLazyInitQuery();

    useEffect(() => {
        triggerInit()
            .unwrap()
            .then((res) => dispatch(saveInit(res)))
            .catch(() => dispatch(saveInit({ languages: [] })));
    }, [triggerInit, dispatch]);

    return (
        <Routes>
            <Route path="*" element={<PrivateRoute />} />
        </Routes>
    );
}

export default App;
